import { REPORT_FORMAT } from 'features/report-generate/report-generate.constants';

export enum REPORT_OPTION {
  PRINT,
  EXPORT,
  EXPORT_XLS,
}

export const REPORT_DATE_FORMAT = 'MM/DD/YYYY';

export const REPORT_OPTION_FORMAT_MAP = {
  [REPORT_OPTION.PRINT]: REPORT_FORMAT.PDF,
  [REPORT_OPTION.EXPORT]: REPORT_FORMAT.PDF,
  [REPORT_OPTION.EXPORT_XLS]: REPORT_FORMAT.XLSX,
};
